__turbopack_context__.v({
  "description": "XAOwza_description",
  "suggestProduct": "XAOwza_suggestProduct",
  "title": "XAOwza_title",
  "wrapper": "XAOwza_wrapper",
});
